import { RecipientPhotoEntity } from '../../../meta-data/app-meta-data.service';

export function cardPosition(value: number, fallback: number): number {
  return Number.isFinite(value) ? Math.max(0, Math.min(100, Math.round(value))) : fallback;
}

export function recipientCardImageStyle(photo: RecipientPhotoEntity) {
  const fit = photo?.CardFitWholePhoto === true;
  return { width: '100%', height: '100%', objectFit: fit ? 'contain' : 'cover',
    objectPosition: fit ? '50% 50%' : `${cardPosition(photo?.CardPositionXPercent, 50)}% ${cardPosition(photo?.CardPositionYPercent, 10)}%` };
}
